<template>
  <info-header-card :icon="submission.icon()" :header="header" :rows="rows" />
</template>

<script>
import SubmissionExtensionTableDTO from "@/DTO/ExtensionTables/SubmissionExtensionTableDTO";
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import SubmissionModel from "@/models/lab/SubmissionModel";
import moment from "moment";

export default {
  name: "SubmissionCard",
  components: {
    InfoHeaderCard
  },
  props: {
    submission: {
      type: Object,
      default: () => new SubmissionModel()
    }
  },
  computed: {
    project() {
      return this.submission.project ? this.submission.getProject() : null;
    },
    customer() {
      return this.project ? this.project.getCustomer() : null;
    },
    header() {
      return `${this.submission.publicNumber()} | ${
        this.customer ? this.customer.full_name : "Customer not specified"
      }`;
    },
    rows() {
      const rows = [
        {
          label: "Identifier",
          value: this.submission.identifier
        },
        {
          label: "Event Code",
          value: this.submission.event_code
        },
        {
          label: "Note",
          value: this.submission.note
        },
        {
          label: "Created On",
          value: moment(this.submission.created_at).format("YYYY-MM-DD")
        }
      ];

      if (this.submission.attribute_1) {
        rows.push(this.setSubmissionExtension('attribute_1'));
      }
      if (this.submission.attribute_2) {
        rows.push(this.setSubmissionExtension('attribute_2'));
      }
      if (this.submission.attribute_3) {
        rows.push(this.setSubmissionExtension('attribute_3'));
      }
      
      return rows;
    }
  },
  methods: {
    setSubmissionExtension(attribute) {
      return {
        label: SubmissionExtensionTableDTO.getHoverTextStatic(this.submission, attribute),
        value: this.submission[attribute],
      }
    }
  },
};
</script>
